import { render, staticRenderFns } from "./insights-show.vue?vue&type=template&id=1e3d7778&scoped=true"
import script from "./insights-show.vue?vue&type=script&lang=js"
export * from "./insights-show.vue?vue&type=script&lang=js"
import style0 from "./insights-show.vue?vue&type=style&index=0&id=1e3d7778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3d7778",
  null
  
)

export default component.exports